import { render, staticRenderFns } from "./JPopupOnlReport.vue?vue&type=template&id=189c4b7c&scoped=true&"
import script from "./JPopupOnlReport.vue?vue&type=script&lang=js&"
export * from "./JPopupOnlReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c4b7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189c4b7c')) {
      api.createRecord('189c4b7c', component.options)
    } else {
      api.reload('189c4b7c', component.options)
    }
    module.hot.accept("./JPopupOnlReport.vue?vue&type=template&id=189c4b7c&scoped=true&", function () {
      api.rerender('189c4b7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/modal/JPopupOnlReport.vue"
export default component.exports